import React, { useEffect } from "react";

import { useSelector } from "react-redux";

import { Box, Typography, Button } from "@mui/material";

import { ExitToApp } from "@mui/icons-material";
import { useGetListQuery } from "../../services/TMDB";
import { RatedCards } from "../index";

const Profile = () => {
  const { user, sessionId } = useSelector((state) => state.user);
  const { data: favoriteMovies ,refetch:reftchFavorites } = useGetListQuery({
    listName: "favorite/movies",
    accountId: user.id,
    sessionId: localStorage.getItem("session_id"),
    Page: 1,
  });
  const { data: watchlistMovies ,refetch:reftchWatchList } = useGetListQuery({
    listName: "watchlist/movies",
    accountId: user.id,
    sessionId: localStorage.getItem("session_id"),
    Page: 1,
  });

  useEffect(() => {
    reftchFavorites()
    reftchWatchList()
  }, []);
  // console.log('Profile')
  console.log(user);
  // const favoriteMovies =[];

  const LogOut = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          My Profile
        </Typography>
        <Button color="inherit" onClick={LogOut}>
          LogOut &nbsp; <ExitToApp />
        </Button>
      </Box>
      {!favoriteMovies?.results?.length && !watchlistMovies?.results?.length ? (
        <Typography variant="h5">Add favoriteMovies</Typography>
      ) : (
        <Box>
          <RatedCards title='Favorite Movies' data={favoriteMovies} />
          <RatedCards title='Watchlist ' data={watchlistMovies} />

        </Box>
      )}
    </Box>
  );
};

export default Profile;
